// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// /opt/devenv/allscs-jhh/repair-ui/~/extract-text-webpack-plugin/loader.js?{"omit":1,"remove":true,"publicPath":"../../"}!/opt/devenv/allscs-jhh/repair-ui/~/vue-style-loader!/opt/devenv/allscs-jhh/repair-ui/~/css-loader?{"minimize":true,"sourceMap":true}!/opt/devenv/allscs-jhh/repair-ui/~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-93c62498","scoped":true,"hasInlineConfig":false}!/opt/devenv/allscs-jhh/repair-ui/~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/imgPreview/imgPreview.vue
// module id = 1310
// module chunks = 0